import check from "./check";
import uncheck from "./uncheck";

/**
 * Run trigger on check or uncheck the checkbox
 * @param {MainClassProps} main
 * @param {HTMLInputElement} target
 * @param {TriggerProps} trigger
 */
const changeCheckbox = (main, target, trigger) => {
  if (target?.checked) {
    check(trigger, main);
  } else {
    uncheck(trigger, main);
  }
};

export default changeCheckbox;
